<template>
  <Modal v-model="visible" title="编辑" width="800" :mask-closable="false" :footer-hide="true" class="my-modal top">
    <Form v-if="visible" ref="form" :model="formData" class="page-form less" :label-width="75">
      <FormItem label="角色名称" prop="name" class="full" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.name" placeholder="请输入新的角色名称" :maxlength="20" clearable />
      </FormItem>

      <FormItem label="备注" class="full">
        <Input v-model="formData.remark" maxlength="50" placeholder="请输入角色备注" clearable />
      </FormItem>
    </Form>

    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="save">确认</Button>
    </div>
  </Modal>
</template>

<script>
import selectTree from "@/components/system/selectTree";
export default {
  props:['getList'],
  components: {
    selectTree
  },
  data() {
    return {
      visible:false,
      formData:{},
    }
  },
  methods:{
    async open(data){
      this.formData = JSON.parse(JSON.stringify(data));
      this.visible = true;
    },

    save(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }

        const formData = JSON.parse(JSON.stringify(this.formData));
        this.$http({
          url: "/buz/rolesExt/updateBaseInfo",
          type: "POST",
          data: {
            name:formData.name,
            id:formData.id,
            remark:this.formData.remark
          },
          apiPermissionCode:'org_5_2'
        }).then(res=>{
          this.visible = false;   
          this.$notice.success("修改成功");
          this.getList();
        })      
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my-modal {  
  /deep/ {
    .ivu-modal-body {
      padding-top: 0;
    }
  }
  .info-text {
    font-size: 12px;
    line-height: 1.5;
    padding-top: 5px;
    color: #ccc;
  }
  .product-title {
    margin-right: 15px;
    font-size: 12px;
  }
  .select-product-btn {
    width: 60px;
    height: 25px;
    line-height: 25px;
    margin-top: 2px;
  }
}
</style>